import CustomApplicationState from "@crescentParts/Store/CustomApplicationState";

export const getAHRISystemToolConfigState = (state: CustomApplicationState) => {
    return state.cpeState?.AHRISystemToolConfig;
};
